import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftCircleFill      } from "react-bootstrap-icons"; // Import the home icon

const NoPermission = () => {
  const navigate = useNavigate();

  return (
    <div
      className={`${styles.container} content-block flex bg-light p-4 rounded inbox-container`}
    >
      <h1 style={styles.heading}>Access Denied</h1>
      <p style={styles.message}>
        You do not have permission to view this page.
      </p>
      <button style={styles.button} onClick={() => navigate(-2)}>
        <ArrowLeftCircleFill      style={{ marginRight: "8px" }} /> Back
      </button>
    </div>
  );
};

export default NoPermission;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    color: "#333",
  },
  heading: {
    fontSize: "2em",
    color: "#e63946",
  },
  message: {
    fontSize: "1.2em",
    color: "#555",
  },
  button: {
    marginTop: "20px",
    padding: "10px 20px",
    fontSize: "1em",
    cursor: "pointer",
    color: "#fff",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "5px",
  },
};
